/* eslint-disable class-methods-use-this */
/* eslint-disable no-param-reassign */
/* eslint-disable no-console */
import tianqiUBT from '@/utils/tianqiUBT';

class Ubt {
  install(Vue) {
    this.initMixin(Vue);
    this.initMethods(Vue);
  }

  /**
   * 自动化pv、pvOut，该方法会采集实例 pageId & pvData
   * @param Vue
   */
  initMixin(Vue) {
    const self = this;
    Vue.mixin({
      mounted() {
        if (this.$options.pageId) {
          self.pageView({
            pageId: this.$options.pageId,
          });
        }
      },
      beforeDestroy() {
        if (this.$options.pageId) {
          self.pageViewOut({
            pageId: this.$options.pageId,
            businessInfo: {
              ...this.$options.pvData,
            },
          });
        }
      },
    });
  }

  /**
   * 挂载全局实例方法
   * @param Vue
   */
  initMethods(Vue) {
    Vue.prototype.$pageView = (params) => {
      this.pageView(params);
    };
    Vue.prototype.$pageViewOut = (params) => {
      this.pageViewOut(params);
    };
    Vue.prototype.$clickButton = (params) => {
      this.clickButton(params);
    };
    Vue.prototype.$moduleExpose = (params) => {
      this.moduleExpose(params);
    };
    Vue.prototype.$customEvent = (params) => {
      this.customEvent(params);
    };
    Vue.prototype.$trackApiTime = (params) => {
      this.trackApiTime(params);
    };
    // 更新天启的默认参数
    Vue.prototype.$updateUbtData = (params) => {
      tianqiUBT.updateData(params);
    };
    Vue.prototype.$sendError = (err) => {
      this.sendError(err);
    };
    Vue.prototype.$customEventWithPointId = (params) => {
      this.customEventWithPointId(params);
    };
    Vue.prototype.$checkField = (pageId, field, allParams) => {
      this.checkField(pageId, field, allParams);
    };
  }

  /**
   * log
   * @param eventId
   * @param params
   */
  log(eventId, params) {
    console.log(`%c Tianqi ${eventId}：`, 'color: #008bf9', params);
  }

  /**
   * 页面埋点
   * @param pageId 必填
   * @param businessInfo
   */
  pageView({
    pageId,
    categoryId = 'hitch',
    businessInfo,
  }) {
    tianqiUBT.pageView({
      pageId,
      categoryId,
      businessInfo,
    });
    this.log('pageView', {
      pageId,
      categoryId,
      businessInfo,
    });
  }

  /**
   * 按钮埋点
   * @param pageId 必填
   * @param buttonName 必填
   * @param businessInfo
   */
  clickButton({
    pageId,
    categoryId = 'hitch',
    buttonName,
    businessInfo,
  }) {
    tianqiUBT.clickButton({
      pageId,
      categoryId,
      buttonName,
      businessInfo,
    });
    this.log('clickButton', {
      pageId,
      categoryId,
      buttonName,
      businessInfo,
    });
  }

  /**
   * 模块曝光
   * @param pageId 必填
   * @param moduleId 必填
   * @param contentId 未传则默认使用moduleId
   * @param exposureTimes 默认1次
   * @param businessInfo
   */
  moduleExpose({
    pageId,
    moduleId,
    contentId = moduleId,
    exposureTimes = '1',
    categoryId = 'hitch',
    businessInfo,
  }) {
    tianqiUBT.moduleExpose({
      pageId,
      moduleId,
      categoryId,
      contentId,
      exposureTimes,
      businessInfo,
    });
    this.log('moduleExpose', {
      pageId,
      moduleId,
      contentId,
      categoryId,
      exposureTimes,
      businessInfo,
    });
  }

  /**
   * 页面离开埋点（数分会根据该埋点整理表格，统计用户停留时长）
   * beforeDestroy 都需要调用
   * 需要的接口数据放在businessInfo字段内
   */
  pageViewOut({
    pageId,
    categoryId = 'hitch',
    businessInfo,
  }) {
    tianqiUBT.pageViewOut({
      pageId,
      categoryId,
      businessInfo,
    });
    this.log('pageViewOut', {
      pageId,
      categoryId,
      businessInfo,
    });
  }

  /**
   * customEvent 自定义事件
   * @param eventId
   * @param ...args
   */
  customEvent({
    eventId,
    categoryId = 'hitch',
    ...args
  }) {
    this.customEventWithPointId({
      pointId: eventId,
      categoryId,
      ...args,
    });
  }

  customEventWithPointId({
    pointId,
    categoryId = 'hitch',
    ...args
  }) {
    tianqiUBT.customEventWithPointId({
      pointId,
      categoryId,
      ...args,
    });
    this.log(`customEventWithPointId:${pointId}`, {
      pointId,
      categoryId,
      ...args,
    });
  }

  /**
   * trackApiTime 事件
   * @param eventId
   * @param ...args
   */
  trackApiTime({
    eventId,
    categoryId = 'hitch',
    ...args
  }) {
    this.customEvent({
      type: 'apm',
      eventId: `hitch-apm-${eventId}`,
      categoryId,
      ...args,
    });
    this.log('trackApiTime', args.apiTime);
  }

  /**
   * Apm的sendError方法，会体现在扁鹊js异常中，无法新增自定义参数
   * @param error js抛出的error对象
   */
  sendError(error) {
    try {
      const { APM } = window.TianQiApm;
      APM.sendError(error);
    } catch (e) {} // eslint-disable-line
  }

  /**
   * 校验页面是否有参数缺失
   * @param pageId
   * @param field
   * @param allParams
   */
  checkField(
    pageId,
    field,
    allParams,
  ) {
    try {
      let fields = [];
      fields = fields.concat(typeof field === 'string' ? [field] : field);
      const missingFields = [];
      fields.forEach((key) => {
        if (!allParams[key]) {
          missingFields.push(key);
        }
      });
      if (missingFields.length) {
        console.log('🟢 [Logger:]  🟦 missingFields 丢失字段', missingFields, allParams);
        this.customEventWithPointId({
          categoryId: 'hitch',
          pointId: `${pageId}-field-missing`,
          businessInfo: {
            ...allParams,
          },
        });
      }
    } catch (err) {
      this.customEventWithPointId({
        categoryId: 'hitch',
        pointId: `${pageId}-field-missing-check-fail`,
        businessInfo: { err },
      });
    }
  }
}
/* eslint-enable class-methods-use-this */
/* eslint-enable no-param-reassign */
/* eslint-enable no-console */
export default new Ubt();
